"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Contract = require("@tableau/api-external-contract-js");
var TableauError_1 = require("../TableauError");
var SheetUtils_1 = require("../Utils/SheetUtils");
var DashboardImpl_1 = require("./DashboardImpl");
var SheetInfoImpl_1 = require("./SheetInfoImpl");
var WorksheetImpl_1 = require("./WorksheetImpl");
var StoryPointImpl = /** @class */ (function () {
    function StoryPointImpl(_storyPointInfoImpl, sheetInfos, registryId, containedSheetInfo) {
        this._storyPointInfoImpl = _storyPointInfoImpl;
        if (containedSheetInfo) {
            this._containedSheetImpl = this.createContainedSheet(containedSheetInfo, sheetInfos, registryId);
        }
    }
    Object.defineProperty(StoryPointImpl.prototype, "index", {
        get: function () {
            return this._storyPointInfoImpl.index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointImpl.prototype, "caption", {
        get: function () {
            return this._storyPointInfoImpl.caption;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointImpl.prototype, "active", {
        get: function () {
            return this._storyPointInfoImpl.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointImpl.prototype, "updated", {
        get: function () {
            return this._storyPointInfoImpl.updated;
        },
        set: function (updated) {
            this._storyPointInfoImpl.updated = updated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointImpl.prototype, "parentStory", {
        get: function () {
            return this._storyPointInfoImpl.parentStory;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointImpl.prototype, "containedSheet", {
        get: function () {
            return this._containedSheetImpl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointImpl.prototype, "storyPointId", {
        get: function () {
            return this._storyPointInfoImpl.storyPointId;
        },
        enumerable: true,
        configurable: true
    });
    StoryPointImpl.prototype.createContainedSheet = function (containedSheetInfo, sheetInfos, registryId) {
        var containedSheetIdx = -1;
        var publishedSheetInfo = SheetUtils_1.SheetUtils.getPublishedSheetInfoByName(containedSheetInfo.name, sheetInfos);
        var containedSheetSize = SheetUtils_1.SheetUtils.createAutomaticSize();
        var isContainedSheetHidden = publishedSheetInfo === undefined;
        var containedSheetUrl = publishedSheetInfo ? publishedSheetInfo.url : '';
        // Contained sheets aren't active - the containing sheet is active.
        var containedSheetActive = false;
        var containedSheetInfoImpl = new SheetInfoImpl_1.SheetInfoImpl(containedSheetInfo.name, SheetUtils_1.SheetUtils.getSheetTypeEnum(containedSheetInfo.sheetType), containedSheetSize, containedSheetIdx, containedSheetActive, isContainedSheetHidden, containedSheetUrl);
        var sheetImpl;
        switch (containedSheetInfoImpl.sheetType) {
            case Contract.SheetType.Worksheet: {
                var vizId = {
                    worksheet: containedSheetInfoImpl.name,
                };
                sheetImpl = new WorksheetImpl_1.WorksheetImpl(containedSheetInfoImpl, registryId, vizId, null, this);
                break;
            }
            case Contract.SheetType.Dashboard: {
                var sheetPath = {
                    sheetName: containedSheetInfoImpl.name,
                    isDashboard: true,
                };
                sheetImpl = new DashboardImpl_1.DashboardImpl(containedSheetInfoImpl, containedSheetInfo.dashboardZones, sheetPath, registryId, this);
                break;
            }
            default: {
                throw new TableauError_1.TableauError(Contract.SharedErrorCodes.ServerError, 'Invalid SheetType');
            }
        }
        return sheetImpl;
    };
    return StoryPointImpl;
}());
exports.StoryPointImpl = StoryPointImpl;
//# sourceMappingURL=StoryPointImpl.js.map